/* Native lazy images keep real src/srcset and all product links in server HTML. */
(() => {
  if (window.rdbProgressiveImages) return;
  window.rdbProgressiveImages = true;
  const seen = new WeakSet();
  const watchImage = image => {
    if (seen.has(image) || image.complete) return;
    seen.add(image);
    image.decoding = 'async';
    const finish = () => {
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
      if (image.naturalWidth && image.getBoundingClientRect().top < innerHeight) {
        image.classList.add('d2-image-arrived');
        image.addEventListener('animationend', () => image.classList.remove('d2-image-arrived'), { once: true });
      }
    };
    image.addEventListener('load', finish, { once: true });
    image.addEventListener('error', finish, { once: true });
  };
  const loadingShelves = new WeakMap();
  const watchShelf = shelf => {
    loadingShelves.get(shelf)?.();
    const rail = shelf.querySelector('[data-product-rail]');
    const bounds = rail?.getBoundingClientRect();
    const images = [...shelf.querySelectorAll('.d2-product-card__media img')].filter(image => {
      if (image.complete || image.closest('[hidden]')) return false;
      if (!bounds) return true;
      const rect = image.getBoundingClientRect();
      return rect.width > 0 && rect.right > bounds.left && rect.left < bounds.right;
    });
    const note = shelf.querySelector('[data-shelf-loading]');
    if (!images.length || !note) return;
    const pending = new Set(images);
    const cleanups = [];
    const timer = setTimeout(() => { if (pending.size) note.hidden = false; }, 180);
    const stop = () => { clearTimeout(timer); note.hidden = true; };
    // Never leave a permanent spinner on a stalled connection or a lazy image
    // still outside the browser's preload distance. Images remain usable normally.
    const deadline = setTimeout(stop, 12000);
    loadingShelves.set(shelf, () => { stop(); clearTimeout(deadline); cleanups.forEach(cleanup => cleanup()); });
    images.forEach(image => {
      watchImage(image);
      const finish = () => {
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
        pending.delete(image);
        if (!pending.size) { stop(); clearTimeout(deadline); }
      };
      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
      cleanups.push(() => { image.removeEventListener('load', finish); image.removeEventListener('error', finish); });
      if (image.complete) finish();
    });
  };
  const shelves = new WeakSet();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      watchShelf(entry.target);
    });
  }, { rootMargin: '400px 0px' }) : null;
  const setup = (scope = document) => {
    scope.querySelectorAll('.d2-product-card__media img[loading="lazy"]').forEach(watchImage);
    scope.querySelectorAll('[data-progressive-shelf]').forEach(shelf => {
      if (shelves.has(shelf)) return;
      shelves.add(shelf);
      observer?.observe(shelf);
    });
  };
  setup();
  document.addEventListener('rdb:catalog-render', event => setup(event.target));
  document.addEventListener('rdb:product-rail-visible', event => watchShelf(event.target));
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
